// import React, { useContext } from 'react';
// import { WishlistContext } from './WishlistContext';
// import { Link } from 'react-router-dom';
// import { FaTrashAlt, FaHeart, FaRegHeart } from 'react-icons/fa';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';


// const Wishlist = () => {
//   const {wishlist, wishlistItems, removeFromWishlist, handleAddToCart } = useContext(WishlistContext);

//   return (
//     <>
//       <Header />
//       <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
//         <h2 className="mb-4 text-center fw-bold">❤️ Your Wishlist</h2>

//         {wishlistItems.length === 0 ? (
//           <div className="text-center text-muted">
//             <FaRegHeart size={40} className="mb-3" style={{ color: '#ff3e6c' }} />
//             <p>Your wishlist is empty. Start adding items!</p>
//           </div>
//         ) : (
//           <div className="row gy-4">
//             {wishlistItems.map((item) => {
//               const discount = item.discount || 0;
//               const originalPrice = item.price || 0;
//               const discountedPrice = discount
//                 ? Math.round(originalPrice - (originalPrice * discount) / 100)
//                 : originalPrice;

//               return (
//                 <div className="col-6 col-md-4 col-lg-3" key={item.id}>
//                   <div
//                     className="card border-0 shadow-sm h-100 position-relative"
//                     style={{ borderRadius: '12px', transition: 'transform 0.2s' }}
//                   >
//                     <img
//                       src={item.image_1}
//                       alt={item.name}
//                       style={{ height: '250px', width: '100%' }}
//                     />
//                     <div className="card-body d-flex flex-column">
//                       <h6 className="card-title fw-bold">{item.name}</h6>

//                       {/* Show variant if exists */}
//                       {item.variant && (
//                         <p className="text-muted mb-1" style={{ fontSize: '0.9rem' }}>
//                           Variant: {item.variant}
//                         </p>
//                       )}

//                       {/* Price & discount display */}
//                       {discount > 0 ? (
//                         <p className="mb-2">
//                           <span
//                             style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}
//                           >
//                             ₹{originalPrice}
//                           </span>
//                           <span style={{ fontWeight: 'bold', color: '#d9534f' }}>
//                             ₹{discountedPrice}
//                           </span>
//                           <span
//                             style={{
//                               backgroundColor: '#d9534f',
//                               color: '#fff',
//                               fontSize: '0.8rem',
//                               padding: '2px 6px',
//                               borderRadius: '4px',
//                               marginLeft: 8,
//                             }}
//                           >
//                             {discount}% OFF
//                           </span>
//                         </p>
//                       ) : (
//                         <p className="card-text text-muted mb-2">₹{originalPrice}</p>
//                       )}

//                       <div className="d-flex justify-content-between mb-2">
//                         <button
//                           className="btn btn-sm btn-outline-success w-100 me-2"
//                           onClick={() => handleAddToCart(item)}
//                           disabled={item.stockQty === 0}
//                         >
//                           Add to Cart
//                         </button>

//                         <button
//                           className="btn btn-sm btn-outline-danger"
//                           onClick={() => removeFromWishlist(item.id)}
//                           title="Remove from wishlist"
//                         >
//                           <FaTrashAlt />
//                         </button>
//                       </div>

//                       <Link to={`/product/${item.id}`} className="btn btn-sm btn-outline-primary w-100">
//                         View Product
//                       </Link>
//                     </div>

//                     <div
//                       className="position-absolute top-0 end-0 p-2"
//                       style={{ fontSize: '1.2rem', color: '#ff3e6c' }}
//                     >
//                       <FaHeart />
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//       <Footer />
//     </>
//   );
// };


// export default Wishlist;

// import React, { useContext } from 'react';
// import { WishlistContext } from './WishlistContext';
// import { Link } from 'react-router-dom';
// import { FaTrashAlt, FaHeart, FaRegHeart } from 'react-icons/fa';
// import Header from '../Header/Header';
// import Footer from '../Footer/Footer';

// const Wishlist = () => {
//   const { wishlist, wishlistItems, removeFromWishlist, handleAddToCart } = useContext(WishlistContext);

//   // Determine if user is logged in
//   const user = JSON.parse(sessionStorage.getItem('userData'));

//   // Choose which list to display
//   const displayList = user?.id ? Object.values(wishlist) : wishlistItems;

//   return (
//     <>
//       <Header />
//       <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
//         <h2 className="mb-4 text-center fw-bold">❤️ Your Wishlist</h2>

//         {displayList.length === 0 ? (
//           <div className="text-center text-muted">
//             <FaRegHeart size={40} className="mb-3" style={{ color: '#ff3e6c' }} />
//             <p>Your wishlist is empty. Start adding items!</p>
//           </div>
//         ) : (
//           <div className="row gy-4">
//             {displayList.map((item) => {
//               const discount = item.discount || 0;
//               const originalPrice = item.price || 0;
//               const discountedPrice = discount
//                 ? Math.round(originalPrice - (originalPrice * discount) / 100)
//                 : originalPrice;

//               return (
//                 <div className="col-6 col-md-4 col-lg-3" key={item.id}>
//                   <div
//                     className="card border-0 shadow-sm h-100 position-relative"
//                     style={{ borderRadius: '12px', transition: 'transform 0.2s' }}
//                   >
//                     <img
//                       src={item.image_1}
//                       alt={item.name}
//                       style={{ height: '250px', width: '100%' }}
//                     />
//                     <div className="card-body d-flex flex-column">
//                       <h6 className="card-title fw-bold">{item.name}</h6>

//                       {item.variant && (
//                         <p className="text-muted mb-1" style={{ fontSize: '0.9rem' }}>
//                           Variant: {item.variant}
//                         </p>
//                       )}

//                       {discount > 0 ? (
//                         <p className="mb-2">
//                           <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}>
//                             ₹{originalPrice}
//                           </span>
//                           <span style={{ fontWeight: 'bold', color: '#d9534f' }}>
//                             ₹{discountedPrice}
//                           </span>
//                           <span
//                             style={{
//                               backgroundColor: '#d9534f',
//                               color: '#fff',
//                               fontSize: '0.8rem',
//                               padding: '2px 6px',
//                               borderRadius: '4px',
//                               marginLeft: 8,
//                             }}
//                           >
//                             {discount}% OFF
//                           </span>
//                         </p>
//                       ) : (
//                         <p className="card-text text-muted mb-2">₹{originalPrice}</p>
//                       )}

//                       <div className="d-flex justify-content-between mb-2">
//                         <button
//                           className="btn btn-sm btn-outline-success w-100 me-2"
//                           onClick={() => handleAddToCart(item)}
//                           disabled={item.stockQty === 0}
//                         >
//                           Add to Cart
//                         </button>

//                         <button
//                           className="btn btn-sm btn-outline-danger"
//                           onClick={() => removeFromWishlist(item.id)}
//                           title="Remove from wishlist"
//                         >
//                           <FaTrashAlt />
//                         </button>
//                       </div>

//                       <Link to={`/product/${item.id}`} className="btn btn-sm btn-outline-primary w-100">
//                         View Product
//                       </Link>
//                     </div>

//                     <div
//                       className="position-absolute top-0 end-0 p-2"
//                       style={{ fontSize: '1.2rem', color: '#ff3e6c' }}
//                     >
//                       <FaHeart />
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//         )}
//       </div>
//       <Footer />
//     </>
//   );
// };

// export default Wishlist;



import React, { useContext, useEffect, useState } from 'react';
import { WishlistContext } from './WishlistContext';
import { Link } from 'react-router-dom';
import { FaTrashAlt, FaHeart, FaRegHeart } from 'react-icons/fa';
import axios from 'axios';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

const Wishlist = () => {
  const { wishlistItems, setWishlistItems, handleAddToCart } = useContext(WishlistContext);

  const [wishlist, setWishlist] = useState({}); // mapping key -> true
  useEffect(() => {
    const user = JSON.parse(sessionStorage.getItem('userData'));
    if (!user?.id) return;
    axios
      .get(`https://api.glocart.in/pages/api/app/wishlist/${user.id}`)
      .then((res) => {
        // const wishMap = {}; 
        // res.data.forEach((item) => {
        //   const key = `${item.productId}_${item.variantId}`;
        //   wishMap[key] = true;
        // });
        setWishlist(res.data);
      })
      .catch((err) => console.error('Error fetching wishlist:', err));
  }, []);

  console.log('this is wishlist11', wishlist)

  const [products, setProducts] = useState([]); // All products
  const [enrichedWishlist, setEnrichedWishlist] = useState([]);

  const user = JSON.parse(sessionStorage.getItem('userData'));
  const userId = user?.id;
  const customerType = user?.businessType;

  // Fetch all products
  useEffect(() => {
    axios
      .get('https://api.glocart.in/pages/api/products/get')
      .then((res) => {
        const updated = res.data.map((p) => {
          const bestVariant = p.variants?.reduce(
            (best, v) => (v.discount > best.discount ? v : best),
            p.variants[0]
          );
          return { ...p, selectedVariant: bestVariant };
        });
        setProducts(updated);
      })
      .catch((err) => console.error('Error fetching products:', err));
  }, []);

  // Merge wishlist items with products
  useEffect(() => {
    if (userId && products.length > 0 && wishlist) {
      // For logged-in user
      const merged = Object.values(wishlist)
        .map((wishItem) => {
          console.log('this is wishItem', wishItem)
          console.log('this is products', products)
          const product = products.find((p) => p.id === wishItem.productId);
          console.log('this is product', product)
          if (!product) return null;
          const variant = product.variants?.find((v) => v.id === wishItem.variantId) || product.selectedVariant;
          return { ...product, ...wishItem, variant };
        })
        .filter(Boolean); // Remove nulls
      console.log('this is merged', merged)
      setEnrichedWishlist(merged);
    } else if (!userId) {
      // Guest user: use wishlistItems directly
      setEnrichedWishlist(wishlistItems);
    }
  }, [userId, wishlist, wishlistItems, products]);

  const displayList = enrichedWishlist;
  console.log('this is displayList', displayList)




  // Helper to save guest wishlist to localStorage
  const saveWishlistToLocalStorage = (list) => {
    localStorage.setItem('wishlistItems', JSON.stringify(list));
  };

  // Remove item
  const removeFromWishlist1 = async (item) => {
    console.log('this is wishlist ',item)

    const user = JSON.parse(sessionStorage.getItem('userData'));
    const userId = user?.id;
    const customerType = user?.businessType;

    if (userId) {
      // Logged-in user → call API
      try {
        await axios.post('https://api.glocart.in/pages/api/app/remove-from-wishlist', {
          productId: item.id,
          variantId: item.variant?.id,
          userId,
          customerType,
        });

        // Remove from local state
        const updatedWishlist = { ...wishlist };
        const key = `${item.id}_${item.variant?.id}`;
        delete updatedWishlist[key];
        setEnrichedWishlist(Object.values(updatedWishlist));
      } catch (err) {
        console.error('Error removing wishlist item:', err);
        alert('Could not remove item. Try again.');
      }
    } else {
      // Guest user → update localStorage
      const updated = wishlistItems.filter((w) => w.id !== item.id);
      setWishlistItems(updated);
      saveWishlistToLocalStorage(updated);
      setEnrichedWishlist(updated);
    }
  };
  const removeFromWishlist = async (item) => {
    console.log('this is item',item)
  const user = JSON.parse(sessionStorage.getItem('userData'));
  console.log('this is user',user)
  const userId = user?.id;
  const customerType = user?.business_type;

  if (userId) {
    // Logged-in user → call API
    try {
      await axios.post('https://api.glocart.in/pages/api/app/remove-from-wishlist', {
        productId: item.id,
        variantId: item.variant?.id,
        userId,
        customerType,
      });

      // Remove from enrichedWishlist state
      const updated = enrichedWishlist.filter(
        (w) => !(w.id === item.id && w.variant?.id === item.variant?.id)
      );
      setEnrichedWishlist(updated);

    } catch (err) {
      console.error('Error removing wishlist item:', err);
      alert('Could not remove item. Try again.');
    }
  } else {
    // Guest user → update localStorage
    const updated = wishlistItems.filter((w) => w.id !== item.id);
    setWishlistItems(updated);
    localStorage.setItem('wishlistItems', JSON.stringify(updated));
    setEnrichedWishlist(updated);
  }
};


  return (
    <>
      <Header />
      <div className="container" style={{ marginTop: '20px', maxWidth: 1200, padding: '0 20px' }}>
        <h2 className="mb-4 text-center fw-bold">❤️ Your Wishlist</h2>

        {displayList.length === 0 ? (
          <div className="text-center text-muted">
            <FaRegHeart size={40} className="mb-3" style={{ color: '#ff3e6c' }} />
            <p>Your wishlist is empty. Start adding items!</p>
          </div>
        ) : (
          <div className="row gy-4">
            {displayList.map((item) => {
              const discount = item.variant?.discount || 0;
              const originalPrice = item.variant?.price || item.price || 0;
              const discountedPrice = discount
                ? Math.round(originalPrice - (originalPrice * discount) / 100)
                : originalPrice;

              const stockQty = item.variant?.stock || 0;

              return (
                <div className="col-6 col-md-4 col-lg-3" key={`${item.id}_${item.variant?.id}`}>
                  <div
                    className="card border-0 shadow-sm h-100 position-relative"
                    style={{ borderRadius: '12px', transition: 'transform 0.2s' }}
                  >
                    <img src={item.image_1} alt={item.name} style={{ height: '250px', width: '100%' }} />
                    <div className="card-body d-flex flex-column">
                      <h6 className="card-title fw-bold">{item.name}</h6>

                      {item.variant && (
                        <p className="text-muted mb-1" style={{ fontSize: '0.9rem' }}>
                          Variant: {item.variant.name || item.variant.unit}
                        </p>
                      )}

                      {discount > 0 ? (
                        <p className="mb-2">
                          <span style={{ textDecoration: 'line-through', color: '#888', marginRight: 8 }}>
                            ₹{originalPrice}
                          </span>
                          <span style={{ fontWeight: 'bold', color: '#d9534f' }}>₹{discountedPrice}</span>
                          <span
                            style={{
                              backgroundColor: '#d9534f',
                              color: '#fff',
                              fontSize: '0.8rem',
                              padding: '2px 6px',
                              borderRadius: '4px',
                              marginLeft: 8,
                            }}
                          >
                            {discount}% OFF
                          </span>
                        </p>
                      ) : (
                        <p className="card-text text-muted mb-2">₹{originalPrice}</p>
                      )}

                      <div className="d-flex justify-content-between mb-2">
                        <button
                          className="btn btn-sm btn-outline-success w-100 me-2"
                          onClick={() => handleAddToCart(item)}
                          disabled={stockQty === 0}
                        >
                          Add to Cart
                        </button>

                        <button
                          className="btn btn-sm btn-outline-danger"
                          //onClick={() => removeFromWishlist(item.id, item.variant?.id,item)}
                           onClick={() => removeFromWishlist(item)}
                          title="Remove from wishlist"
                        >
                          <FaTrashAlt />
                        </button>
                      </div>

                      <Link to={`/product/${item.id}`} className="btn btn-sm btn-outline-primary w-100">
                        View Product
                      </Link>
                    </div>

                    <div className="position-absolute top-0 end-0 p-2" style={{ fontSize: '1.2rem', color: '#ff3e6c' }}>
                      <FaHeart />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Wishlist;
